export const GET_ALL_SLIDE = 'GET_ALL_SLIDE';
export const GET_NEXT_IMAGE = 'GET_NEXT_IMAGE';
